import { io, type Socket } from 'socket.io-client'

import { config } from '@/config'

let platformSocket: Socket | null = null

export function getPlatformSocket(): Socket {
	if (!platformSocket) {
		platformSocket = io(`${config.fridge.superUrl}/platform`, {
			autoConnect: false,
			withCredentials: true,
			transports: ['websocket', 'polling'],
			auth: (cb) => {
				cb(getSocketAuth())
			},
		})
	}

	return platformSocket
}

export function connectPlatformSocket(): Socket {
	const socket = getPlatformSocket()
	socket.auth = getSocketAuth()
	if (!socket.connected) {
		socket.connect()
	}
	return socket
}

function getSocketAuth() {
	return {
		sessionId: localStorage.getItem('x-session-id') ?? undefined,
	}
}
